import arrowSvg from './arrow.svg';
import bulbSvg from './bulb.svg';
import checkedCircleSvg from './checkedCircle.svg';
import crossCircleSvg from './crossCircle.svg';
import downloadSvg from './download.svg';
import feedbackSvg from './feedback.svg';
import fullMonjinLogoSvg from './fullMonjinLogo.svg';
import helpIconSvg from './helpIcon.svg';
import infoSvg from './info.svg';
import launchSvg from './launch.svg';
import lightBulbSvg from './lightBulb.svg';
import monjinLogoSvg from './monjinLogo.svg';
import videoRecordSvg from './videoRecord.svg';
import viewSvg from './view.svg';

// Create icon configuration in alphabetical order
export const arrow = {
    name: 'arrow',
    svg: arrowSvg,
    viewBox: '0 0 24 24'
};

export const bulb = {
    name: 'bulb',
    svg: bulbSvg,
    viewBox: '0 0 24 24'
};

export const info = {
    name: 'info',
    svg: infoSvg,
    viewBox: '0 0 24 24'
};

export const monjinLogo = {
    name: 'monjin-logo',
    svg: monjinLogoSvg,
    viewBox: '0 0 24 24'
};

export const fullMonjinLogo = {
    name: 'monjin-logo-full',
    svg: fullMonjinLogoSvg,
    viewBox: '0 0 90 40'
};


export const video = {
    name: 'video-record',
    svg: videoRecordSvg,
    viewBox: '0 0 24 24'
};

export const lightBulb = {
    name: 'light-bulb',
    svg: lightBulbSvg,
    viewBox: '0 0 24 24'
};

export const view = {
    name: 'view',
    svg: viewSvg,
    viewBox: '0 0 24 24'
};

export const checkedCircle = {
    name: 'checked-circle',
    svg: checkedCircleSvg,
    viewBox: '0 0 24 24'
};

export const crossCircle = {
    name: 'cross-circle',
    svg: crossCircleSvg,
    viewBox: '0 0 24 24'
};

export const launch = {
    name: 'launch',
    svg: launchSvg,
    viewBox: '0 0 24 24'
};

export const help = {
    name: 'help',
    svg: helpIconSvg,
    viewBox: '0 0 24 24'
};


export const feedback = {
    name: 'feedback',
    svg: feedbackSvg,
    viewBox: '0 0 24 24'
};

export const download = {
    name: 'download',
    svg: downloadSvg,
    viewBox: '0 0 24 24'
};

